import { useState } from 'react';

const useError = () => {
  const [error, setError] = useState(null);

  const showError = (errorMessage) => {
    setError(errorMessage);
  };

  const clearError = () => {
    setError(null);
  };

  return {
    error,
    showError,
    clearError,
  };
};

export default useError;